import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';


const firebaseConfig = {
  apiKey: "AIzaSyB2mU_v8c7Y_QoTGDsL3DmRXZmRrFxrijM",
  authDomain: "datavizbi-b6f1b.firebaseapp.com",
  projectId: "datavizbi-b6f1b",
  storageBucket: "datavizbi-b6f1b.firebasestorage.app",
  messagingSenderId: "912024455212",
  appId: "1:912024455212:web:5672624085eb1633a92989"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export default app;

;